import * as THREE from 'three';

// GLOBAL WIND. One source of truth for "which way + how hard the wind is blowing right now", so canopies,
// grass, rain streaks, falling leaves and dropped fruit all lean the SAME way in the SAME gust -- which is
// what actually sells wind (three unrelated wiggles do not). WIND_DIR is a unit XZ vector the sway leans
// along; WIND_GUST scales amplitude (~0.05 dead calm .. ~1.3 hard gust). Both are shared uniform objects so
// the foliage shaders read them with no per-frame JS. WindField.update() evolves them from layered noise.
export const WIND_DIR = { value: new THREE.Vector2(0.85, 0.12) };
export const WIND_GUST = { value: 0.4 };

export class WindField {
  private angle = 0.6;                 // current wind heading in the XZ plane (radians)
  dirX = Math.cos(0.6);                // JS-side copies for the particle / fruit-fall logic (no uniform reads)
  dirZ = Math.sin(0.6);
  gust = 0.4;                          // 0.05 calm .. ~1.3 hard gust
  gusting = false;                     // true on the frame a strong gust is peaking (drives leaf/fruit spawns)

  // `time` is the shared sky clock in seconds. Direction WANDERS slowly (heading drifts over minutes) and
  // strength PULSES (a slow base with faster ramps that occasionally stack into a strong gust).
  update(time: number): void {
    this.angle = 0.6 + Math.sin(time * 0.011) * 1.4 + Math.sin(time * 0.037 + 2.1) * 0.5;
    this.dirX = Math.cos(this.angle);
    this.dirZ = Math.sin(this.angle);
    const g = 0.42 + 0.34 * Math.sin(time * 0.19) + 0.24 * Math.sin(time * 0.53 + 1.3) + 0.14 * Math.sin(time * 1.1 + 0.4);
    const clamped = Math.max(0.05, Math.min(1.3, g));
    this.gusting = clamped > 1.0 && clamped > this.gust; // rising through a strong gust this frame
    this.gust = clamped;
    WIND_DIR.value.set(this.dirX, this.dirZ);
    WIND_GUST.value = clamped;
  }
}
